export const COACH_NOTES_STATE_IS_LOADING = 'COACH_NOTES_STATE_IS_LOADING';
